/**
 * Price calculation and summary module for contract creation.
 * Calculates subtotal, discount, VAT, and total from selected offer prices.
 */

import { formatCurrency } from '../../lib/helpers';

export interface PriceSummaryElements {
    summaryCard: HTMLElement;
    subtotalEl: HTMLElement;
    discountLabelEl: HTMLElement;
    discountEl: HTMLElement;
    vatLabelEl: HTMLElement;
    vatEl: HTMLElement;
    totalEl: HTMLElement;
    discountInput: HTMLInputElement | null;
    vatPct: number;
}

/**
 * Calculate and update the price summary from selected offer prices
 */
export function updatePriceSummary(elements: PriceSummaryElements) {
    let subtotal = 0;
    const transportSeatCount = document.querySelectorAll<HTMLInputElement>('.traveller-uses-transport:checked').length;

    // Transport flat-price checkboxes × seat count
    document
        .querySelectorAll<HTMLInputElement>('[name$=".SelectedOfferPriceIds"]:checked')
        .forEach((cb) => {
            const price = parseFloat(cb.getAttribute('data-price') || '0') || 0;
            subtotal += price * transportSeatCount;
        });

    // Sub-range (Accommodation, Insurance): use computed line totals from date picker
    document
        .querySelectorAll<HTMLElement>('[data-line-total]')
        .forEach((el) => {
            subtotal += parseFloat(el.getAttribute('data-line-total') || '0') || 0;
        });

    const discountPct = parseFloat(elements.discountInput?.value || '0') || 0;
    const vatPct = elements.vatPct;

    const discountAmt = subtotal * (discountPct / 100);
    const afterDiscount = subtotal - discountAmt;
    const vatAmt = afterDiscount * (vatPct / 100);
    const total = afterDiscount + vatAmt;

    elements.subtotalEl.textContent = formatCurrency(subtotal);
    elements.discountLabelEl.textContent = `Discount (${discountPct}%):`;
    elements.discountEl.textContent = `-${formatCurrency(discountAmt)}`;
    elements.vatLabelEl.textContent = `VAT (${vatPct}%):`;
    elements.vatEl.textContent = `+${formatCurrency(vatAmt)}`;
    elements.totalEl.textContent = formatCurrency(total);

    elements.summaryCard.classList.toggle('d-none', subtotal <= 0);
}

/**
 * Setup event listeners for discount input changes
 */
export function setupPriceSummaryListeners(elements: PriceSummaryElements, updateCallback: () => void) {
    if (elements.discountInput) {
        elements.discountInput.addEventListener('input', updateCallback);
    }
}
